/* eslint-disable no-unused-vars */
import { useState, useEffect } from "react";
import { useLazyQuery, useMutation } from "@apollo/client";
import {
  GET_CONTRACT,
  UPDATE_STATUS_CONTRACT,
} from "../../../services/contract/contracts";
import styled from "styled-components";
import { ArrowDownSmallIcon } from "../../../assets/icons";
import { ButtonIcon } from "../../ui/ButtonIcon";
import { useContract } from "../../../redux/contractReducer";
import { ModalCambiarEstatus } from "./ModalCambiarEstatus";

const Container = styled.div`
  background-color: #fff;
  border-radius: 24px;
  padding: 40px;
  width: 1200px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  box-shadow: 19px 70px 29px rgba(4, 3, 63, 0.01),
    11px 40px 25px rgba(4, 3, 63, 0.03), 5px 18px 18px rgba(4, 3, 63, 0.04),
    1px 4px 10px rgba(4, 3, 63, 0.05), 0px 0px 0px rgba(4, 3, 63, 0.05);
  margin-bottom: 30px;
  @media only screen and (max-width: 1280px) {
    width: 90vw;
    padding: 40px 20px;
  }
`;

const ModuleTitle = styled.p`
  color: var(--neutrals-charcoal);
  font-size: 24px;
  font-weight: 700;
`;

const Divider = styled.div`
  width: 100%;
  height: 2px;
  background-color: var(--primary-pistachio);
`;

const DataContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 300px);
  grid-template-rows: 1fr 1fr 1fr;
  row-gap: 18px;
  justify-content: space-between;
  margin-top: 14px;
  @media only screen and (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
  @media only screen and (max-width: 425px) {
    grid-template-columns: repeat(1, 1fr);
    gap: 20px;
  } ;
`;

const StyledTextWrapper = styled.div`
  display: flex;
`;

const StyledText = styled.p`
  font-weight: 400;
  color: var(--neutrals-charcoal);
  font-size: 16px;
`;

const StyledTextBold = styled.p`
  font-weight: 800;
  color: var(--neutrals-charcoal);
  font-size: 16px;
`;

export const DatosContacto = ({ modal, setModal, setStatus , dataContact = null }) => {
  const [contact, setContact] = useState([]);
  const { setContract, contractState } = useContract();
  //MODAL
  const [showChangeStatus, setShowChangeStatus] = useState(false);

  const [getAllContractById] = useLazyQuery(GET_CONTRACT, {
    fetchPolicy: "network-only",
    onCompleted({ getAllContractById }) {
      if (getAllContractById.statusCode === 200) {
        const resultFormatJson = JSON.parse(getAllContractById.response);
        setContract(resultFormatJson[0]);
      }
    },
  });

  const [updateStatusContract] = useMutation(UPDATE_STATUS_CONTRACT);

  const transformDate = (data) => {
    try {
    const formatDate = new Date(data);
    const result = formatDate.toLocaleDateString("es-MX", data);
    return result;
    } catch (error) {
    }
  };

  useEffect(() => {
    if (contractState?.contrato_id !== null) {
      setContact([contractState]);
    } else {
      setContact([]);
    }
  }, [contractState]);
  useEffect(() => {
  }, [contact]);
  useEffect(() => {
    if (dataContact && Object.keys(dataContact).length > 0) {
      getAllContractById({
        variables: {
          idContract: dataContact.contrato_id,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataContact]);

  const handleUpdateStatus = (contract, dataStatus) => {
    updateStatusContract({
      variables: {
        idContract: contract.contrato_id,
        idStatus: dataStatus,
      },
    });
  };
  // eslint-disable-next-line no-unused-vars

  const changeStatus = async (tipo) => {
    setModal(true)
    setShowChangeStatus(false);
    setStatus(tipo);
  };

  
  return (
    <>
      {contact.length > 0 ? (
        <>
          {contact.map((contract, index) => (
            <Container key={index}>
              <ModuleTitle>Datos del contracto</ModuleTitle>
              <Divider />
              <DataContainer>
                <StyledTextWrapper>
                  <StyledTextBold>Nombre del cliente:</StyledTextBold>
                  <StyledText> {contract.nombre}</StyledText>
                </StyledTextWrapper>
                <StyledTextWrapper>
                  <StyledTextBold>Estatus de la póliza:</StyledTextBold>
                  <StyledText> {contract.valor_est_cont} </StyledText>
                </StyledTextWrapper>
                <StyledTextWrapper>
                  <StyledTextBold>Suma asegurada:</StyledTextBold>
                  <StyledText> ${contract.sum} </StyledText>
                </StyledTextWrapper>
                <StyledTextWrapper>
                  <StyledTextBold>Número del contrato:</StyledTextBold>
                  <StyledText>
                    {" "}
                    #{String(contract.contrato_id).padStart(4, "0")}
                  </StyledText>
                </StyledTextWrapper>
                <StyledTextWrapper>
                  <StyledTextBold>Fecha de emisión:</StyledTextBold>
                  <StyledText>{transformDate(contract.fecha_emi)}</StyledText>
                </StyledTextWrapper>
                <StyledTextWrapper>
                  <StyledTextBold>% de participación:</StyledTextBold>
                  <StyledText> {contract.porcentaje}% </StyledText>
                </StyledTextWrapper>
                <StyledTextWrapper>
                  <StyledTextBold>Vigencia del contrato:</StyledTextBold>
                  <StyledText>
                    {transformDate(contract.fecha_ini)} -{" "}
                    {transformDate(contract.fecha_fin)}{" "}
                  </StyledText>
                </StyledTextWrapper>
                <StyledTextWrapper>
                  <StyledTextBold>Ramo:</StyledTextBold>
                  <StyledText> {contract.valor_ramo} </StyledText>
                </StyledTextWrapper>
                <StyledTextWrapper>
                  <StyledTextBold>Moneda:</StyledTextBold>
                  <StyledText> {contract.valor_moneda}</StyledText>
                </StyledTextWrapper>
              </DataContainer>
              <ButtonIcon
                text={`Estatus ${contract.valor_est_cont}`}
                style={{
                  borderRadius: "20px",
                  alignSelf: "flex-end",
                  position: "relative",
                }}
                icon={<ArrowDownSmallIcon />}
                onClick={() => setShowChangeStatus((prev) => !prev)}
              />
              <div style={{ position: "relative" }}>
                <ModalCambiarEstatus
                  showChangeStatus={showChangeStatus}
                  setShowChangeStatus={setShowChangeStatus}
                  changeStatus={changeStatus}
                />
              </div>
            </Container>
          ))}
        </>
      ) : (
        <Container>
          <ModuleTitle>Datos del contrato</ModuleTitle>
          <Divider />
          <DataContainer>
            <StyledTextWrapper>
              <StyledTextBold>Nombre del cliente: </StyledTextBold>
              <StyledText> Nombre</StyledText>
            </StyledTextWrapper>
            <StyledTextWrapper>
              <StyledTextBold>Estatus de la póliza: </StyledTextBold>
              <StyledText> Estatus</StyledText>
            </StyledTextWrapper>
            <StyledTextWrapper>
              <StyledTextBold>Suma asegurada:</StyledTextBold>
              <StyledText> $0</StyledText>
            </StyledTextWrapper>
            <StyledTextWrapper>
              <StyledTextBold>Número del contrato:</StyledTextBold>
              <StyledText> #00000</StyledText>
            </StyledTextWrapper>
            <StyledTextWrapper>
              <StyledTextBold>Fecha de emisión:</StyledTextBold>
              <StyledText>00/00/0000</StyledText>
            </StyledTextWrapper>
            <StyledTextWrapper>
              <StyledTextBold>% de participación:</StyledTextBold>
              <StyledText> %0 </StyledText>
            </StyledTextWrapper>
            <StyledTextWrapper>
              <StyledTextBold>Vigencia del contrato:</StyledTextBold>
              <StyledText>00/00/0000 - 00/00/0000 </StyledText>
            </StyledTextWrapper>
            <StyledTextWrapper>
              <StyledTextBold>Ramo:</StyledTextBold>
              <StyledText> Ramo </StyledText>
            </StyledTextWrapper>
            <StyledTextWrapper>
              <StyledTextBold>Moneda:</StyledTextBold>
              <StyledText> USD/MXP</StyledText>
            </StyledTextWrapper>
          </DataContainer>
          <ButtonIcon
            text={"Estatus"}
            style={{
              borderRadius: "20px",
              alignSelf: "flex-end",
              position: "relative",
            }}
            icon={<ArrowDownSmallIcon />}
          />
          <div style={{ position: "relative" }}>
            <ModalCambiarEstatus
              showChangeStatus={showChangeStatus}
              setShowChangeStatus={setShowChangeStatus}
              changeStatus={changeStatus}
            />
          </div>
        </Container>
      )}
    </>
  );
};
